/**
 * Tiny imperative toast. Could be a Preact component but the API is so
 * small that a single global function is friendlier — every module just
 * imports `toast`.
 *
 * The toast root is created lazily on first call so SSR / testing
 * environments without a document don't break.
 */
let el: HTMLDivElement | null = null;
let timer: ReturnType<typeof setTimeout> | null = null;

function ensureEl(): HTMLDivElement {
  if (el) return el;
  el = document.createElement("div");
  el.className = "toast";
  el.setAttribute("role", "status");
  el.setAttribute("aria-live", "polite");
  document.body.appendChild(el);
  return el;
}

export function toast(message: string, ms = 1800): void {
  if (typeof document === "undefined") return;
  const node = ensureEl();
  node.textContent = message;
  node.classList.add("open");
  if (timer) clearTimeout(timer);
  timer = setTimeout(() => node.classList.remove("open"), ms);
}
